import { BaseService } from '@services/BaseService'

const resource = 'patients'

class PatientService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const patientService = new PatientService()
